module.exports = "/images/ny-street-8.jpg";